module.exports = __webpack_public_path__ + "static/media/loveit.69b311c8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/emojis/loveit.gif
// module id = 168
// module chunks = 0